<template>
  <div class="guest-page">
    <el-form :model="queryCondition" :inline="true" label-position="left">
      <el-form-item label="名称">
        <el-input
          v-model="queryCondition.GuestName"
          placeholder="输入名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="代码">
        <el-input
          v-model="queryCondition.GuestCode"
          placeholder="输入代码"
        ></el-input>
      </el-form-item>
      <el-form-item label="角色">
        <el-select v-model="queryCondition.RoleType" placeholder="请选择">
          <el-option label="全部" value="0"></el-option>
          <el-option
            v-for="item in roleTypes"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-radio-group v-model="queryCondition.EnableFlag">
          <el-radio :label="100">全部</el-radio>
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="0">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onBtnSearch">查询</el-button>
        <!--<el-button type="primary" @click="onAddGuest">添加</el-button>
        <el-button type="primary" @click="dialogImportVisible=true">导入</el-button>-->
      </el-form-item>
    </el-form>

    <div>
      <el-pagination
        @size-change="onSizeChange"
        @current-change="onCurrentChange"
        :current-page="queryCondition.pageindex"
        :page-sizes="[15, 20, 30, 50, 100]"
        :page-size="queryCondition.pagesize"
        layout="total,sizes,prev,pager,next,jumper"
        :total="queryCondition.count"
      >
      </el-pagination>
    </div>
    <el-table :data="guestDatas" border style="width: 100%" v-loading="loading">
      <el-table-column
        prop="GuestName"
        label="名称"
        width="180"
      ></el-table-column>
      <el-table-column
        prop="GuestCode"
        label="编码"
        width="180"
      ></el-table-column>
      <el-table-column prop="Alias" label="别名"></el-table-column>
      <el-table-column prop="RoleTypeName" label="角色">
        <template slot-scope="scope">
            <span class="cellunderline" @click="showUpdateRoleType(scope.row)">{{ scope.row.RoleTypeName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="DeptName" label="部门名称"></el-table-column>
      <el-table-column prop="Sex" label="性别"></el-table-column>
      <el-table-column prop="NativePlace" label="籍贯"></el-table-column>
      <el-table-column prop="EnableFlag" label="有效" width="150">
        <template slot-scope="scope">
          <el-tag :type="scope.row.EnableFlag == 1 ? 'success' : 'info'">{{
            scope.row.EnableFlag == 1 ? "启用" : "禁用"
          }}</el-tag>
          <el-tag :type="scope.row.WeOpenID == '' ? 'info' : 'success'">{{
            scope.row.WeOpenID == "" ? "未绑定" : "已绑定"
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <!--<el-button @click="changeEnable(scope.row)" :type="scope.row.EnableFlag==1?'warning':'success'" size="mini">{{scope.row.EnableFlag==1?'禁用':'启用'}}</el-button>
          <el-button @click="onEditGuest(scope.row)" type="primary" size="mini">编辑</el-button>-->
          <el-button
            @click="onShowWXQRCode(scope.row)"
            type="primary"
            size="mini"
            >二维码</el-button
          >
          <el-button
            v-if="scope.row.RoleType == 2"
            @click="onShowAgent(scope.row)"
            type="primary"
            size="mini"
            >代理</el-button
          >
          <el-button
            v-if="scope.row.WeOpenID != ''"
            @click="onWXUnbind(scope.row)"
            type="primary"
            size="mini"
            >解绑</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!--修改客户对话框 -->
    <el-dialog
      title="添加/修改客户"
      :visible.sync="dlgAddGuest"
      :close-on-click-modal="false"
    >
      <el-form
        label-width="120px"
        :model="editGuest"
        :rules="rules"
        ref="guestForm"
      >
        <el-form-item label="名称" prop="GuestName">
          <el-input
            v-model="editGuest.GuestName"
            placeholder="输入名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="别名">
          <el-input v-model="editGuest.Alias" placeholder="输入别名"></el-input>
        </el-form-item>
        <el-form-item label="部门">
          <el-input
            v-model="editGuest.DeptName"
            placeholder="输入部门"
          ></el-input>
        </el-form-item>
        <el-form-item label="角色">
          <el-select v-model="editGuest.RoleType" placeholder="请选择">
            <el-option
              v-for="item in roleTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="性别">
          <el-input v-model="editGuest.Sex" placeholder="输入性别"></el-input>
        </el-form-item>
        <el-form-item label="籍贯">
          <el-input
            v-model="editGuest.NativePlace"
            placeholder="输入籍贯"
          ></el-input>
        </el-form-item>
        <el-form-item label="地址">
          <el-input
            v-model="editGuest.Address"
            placeholder="输入地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="不显示的商品">
          <el-input v-model="editGuest.NotDisplayGoods"></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input
            v-model="editGuest.Remark"
            placeholder="输入描述"
          ></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-switch
            v-model="editGuest.EnableFlag"
            active-value="0"
            inactive-value="1"
            active-color="#dcdfe6"
            inactive-color="#13ce66"
            active-text="禁用"
            inactive-text="启用"
          ></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dlgAddGuest = false" :disabled="loading"
          >取 消</el-button
        >
        <el-button type="primary" @click="onSaveGuest" :disabled="loading"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!--代理客户对话框 -->
    <el-dialog
      title="代理客户"
      :visible.sync="dlgAgent"
      :close-on-click-modal="false"
    >
      <el-form label-width="120px" :model="agentGuest">
        <el-form-item label="业务员">
          <label>{{ agentGuest.GuestName }}</label>
        </el-form-item>
        <el-form-item label="代理客户">
          <el-select
            v-model="selAgentCode"
            filterable
            remote
            placeholder="请输入客户名"
            :remote-method="onFindGuest"
          >
            <el-option
              v-for="item in qryGuests"
              :key="item.GuestCode"
              :label="item.GuestName"
              :value="item.GuestCode"
            ></el-option>
          </el-select>
          <el-button type="primary" @click="onAddAgentGuest" :disabled="loading"
            >添加代理客户</el-button
          >
        </el-form-item>
      </el-form>
      <el-tag>业务员代理的客户</el-tag>
      <el-table
        :data="agentGuestList"
        border
        style="width: 100%"
        v-loading="loading"
      >
        <el-table-column
          prop="GuestName"
          label="名称"
          width="180"
        ></el-table-column>
        <el-table-column prop="Alias" label="别名"></el-table-column>
        <el-table-column prop="MobilePhone" label="电话"></el-table-column>
        <el-table-column prop="Address" label="地址"></el-table-column>
        <el-table-column label="操作" width="50">
          <template slot-scope="scope">
            <el-button
              @click="onDelSForGuest(scope.row)"
              type="danger"
              size="mini"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dlgAgent = false" :disabled="loading"
          >取 消</el-button
        >
      </span>
    </el-dialog>

    <!--修改用户角色 -->
    <el-dialog
      title="修改用户角色"
      :visible.sync="dlgUpdateRoleType"
      :close-on-click-modal="false"
    >
      <el-form label-width="120px" :model="updateRoleGuest">
        <el-form-item label="更新角色的用户">
          <label>{{ updateRoleGuest.GuestName }}</label>
        </el-form-item>
        <el-form-item label="角色">
          <el-select v-model="updateRoleGuest.RoleType">
            <el-option
              v-for="item in roleTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dlgUpdateRoleType = false" :disabled="loading"
          >取 消</el-button
        >
        <el-button type="primary" @click="onUpdateGuestRole" :disabled="loading"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!--导入-->
    <el-dialog title="导入Excel" :visible.sync="dialogImportVisible">
      <el-upload
        ref="uploada"
        action="./adm/guest/import"
        :before-remove="beforeRemove"
        :before-upload="beforeUpload"
        :on-error="uploadFail"
        :on-success="uploadSuccess"
        accept=".xls,.xlsx"
      >
        <el-button size="small" type="primary" :disabled="processing">{{
          uploadTip
        }}</el-button>
        <div slot="tip" class="el-upload__tip">
          只能上传.xls,.xlsx文件，且不超过4M
        </div>
      </el-upload>
    </el-dialog>

    <!--导入-->
    <el-dialog title="导入Excel" :visible.sync="dialogWXQRCodeVisible">
      <div>
        <img class="img" :src="guestWXQRCodeSrc" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogWXQRCodeVisible = false" :disabled="loading"
          >取 消</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  searchGuests,
  saveGuest,
  getSForGuestList,
  saveSForGuest,
  delSForGuest,
  changeGuestRole,
  unbindGuestWX,
} from "../../api/guest";
import { isNullOrEmpty, appConfig } from "../../api/utils";

export default {
  data() {
    return {
      queryCondition: {
        GuestName: "",
        GuestCode: "",
        RoleType: "0",
        EnableFlag: 100,
        pageindex: 1,
        pagesize: 20,
        count: 0,
      },
      guestDatas: [],
      agentGuestList: [],
      dlgAddGuest: false,
      dlgAgent: false,
      dlgUpdateRoleType: false,
      editGuest: { ID: 0, GuestName: "", GuestCode: "", EnableFlag: 1 },
      agentGuest: {},
      updateRoleGuest:{},
      qryGuests: [],
      selAgentCode: "",
      loading: false,
      rules: {
        GuestName: [{ required: true, message: "请输入名称", trigger: "blur" }],
        GuestCode: [{ required: true, message: "请输入代码", trigger: "blur" }],
      },
      roleTypes: [
        { value: 1, label: "普通用户" },
        { value: 2, label: "业务员" },
        { value: 3, label: "运营用户" },
        { value: 99, label: "管理员" },
      ],
      dialogImportVisible: false,
      uploadTip: "点击上传",
      processing: false,
      dialogWXQRCodeVisible: false,
      guestWXQRCodeSrc: "",
    };
  },
  created() {
    this.onSearch();
  },
  methods: {
    changeEnable: function (guest) {
      var saveGuestObj = Object.assign({}, guest, {
        EnableFlag: guest.EnableFlag == 1 ? 0 : 1,
      });
      this.loading = true;
      saveGuest(saveGuestObj).then(
        (resp) => {
          this.loading = false;
          if (resp.data.code == 100) {
            this.$notify.success({ title: "成功", message: "保存成功" });
            guest.EnableFlag = saveGuestObj.EnableFlag;
          } else {
            this.$notify.error({ title: "失败", message: resp.data.msg });
          }
        },
        (err) => {
          this.$notify.error({ title: "修改失败", message: err.statusText });
          this.loading = false;
        }
      );
    },
    onBtnSearch: function () {
      this.queryCondition.pageindex = 1;
      this.guestDatas = [];
      this.onSearch();
    },
    onSearch: function () {
      var that = this;
      that.loading = true;
      searchGuests(this.queryCondition).then(
        (resp) => {
          that.loading = false;
          if (resp.data.code == 100) {
            let gDatas = resp.data.data.Data;
            if (!gDatas) return;
            for (var i = 0; i < gDatas.length; i++) {
              gDatas[i].RoleTypeName = this.getRoleName(gDatas[i].RoleType);
            }
            that.guestDatas = gDatas;
            that.queryCondition.count = resp.data.data.Count;
          } else {
            that.$notify.error({
              title: "失败",
              message: "加载数据失败：" + resp.data.msg,
            });
          }
        },
        (err) => {
          that.loading = false;
          that.$notify.error({ title: "查询失败", message: err.statusText });
        }
      );
    },
    getRoleName: function (type) {
      switch (type) {
        case 1:
          return "普通用户";
        case 2:
          return "业务员";
        case 3:
          return "运营用户";
        case 99:
          return "管理员";
      }
    },
    onAddGuest: function () {
      this.editGuest = {
        ID: 0,
        GuestName: "",
        GuestCode: "",
        DeptName: "",
        Sex: "",
        NativePlace: "",
        Remark: "",
        EnableFlag: 1,
      };
      this.dlgAddGuest = true;
      if (this.$refs["guestForm"]) this.$refs["guestForm"].resetFields();
    },
    onEditGuest: function (Guest) {
      this.editGuest = Object.assign({}, Guest);
      this.editGuest.EnableFlag = this.editGuest.EnableFlag + "";
      this.dlgAddGuest = true;
      if (this.$refs["guestForm"]) this.$refs["guestForm"].resetFields();
    },
    onSaveGuest: function () {
      var isValid = false;
      this.$refs["guestForm"].validate((valid) => {
        isValid = valid;
        return valid;
      });
      if (!isValid) {
        this.$notify.info({ title: "警告", message: "请按要求填写数据" });
        return;
      }

      this.dlgAddGuest = false;
      this.editGuest.EnableFlag = this.editGuest.EnableFlag * 1;
      this.loading = true;
      var that = this;
      saveGuest(this.editGuest).then(
        (resp) => {
          that.loading = false;
          if (resp.data.code == 100) {
            that.$notify.success({ title: "成功", message: "保存成功" });
            if (that.editGuest.ID == 0) {
              that.onSearch();
            } else {
              for (var i = 0; i < that.guestDatas.length; i++) {
                if (that.guestDatas[i].ID == that.editGuest.ID) {
                  that.editGuest.RoleTypeName = that.getRoleName(
                    that.editGuest.RoleType
                  );
                  that.guestDatas[i] = Object.assign(
                    that.guestDatas[i],
                    that.editGuest
                  );
                  break;
                }
              }
            }
          } else {
            that.$notify.error({ title: "失败", message: resp.data.msg });
          }
        },
        (err) => {
          that.$notify.error({ title: "保存", message: err.statusText });
          that.loading = false;
        }
      );
    },
    onSizeChange(curSize) {
      this.queryCondition.pagesize = curSize;
      this.queryCondition.pageindex = 1;
      this.onSearch();
    },
    onCurrentChange(curIndex) {
      this.queryCondition.pageindex = curIndex;
      this.onSearch();
    },
    onShowAgent(Guest) {
      this.freshGuestList(Guest.GuestCode);
      this.agentGuest = Guest;
      this.dlgAgent = true;
    },
    freshGuestList(gcode) {
      this.agentGuestList = [];
      var that = this;
      getSForGuestList(gcode).then((resp) => {
        if (resp.data.code == 100) {
          if (resp.data.data) {
            that.agentGuestList = resp.data.data;
          }
        }
        this.agentGuestList;
      });
    },
    onFindGuest(guestName) {
      if (guestName !== "") {
        var that = this;
        searchGuests({
          GuestName: guestName,
          EnableFlag: "1",
          pageindex: 1,
          pagesize: 50,
        }).then((resp) => {
          if (resp.data.code == 100) {
            let gDatas = resp.data.data.Data;
            that.qryGuests = gDatas;
          }
        });
      }
    },
    onAddAgentGuest() {
      if (this.selAgentCode == "") {
        this.$notify.error({ title: "失败", message: "请输入并选择客户" });
        return;
      }
      if (this.selAgentCode == this.agentGuest.GuestCode) {
        this.$notify.error({
          title: "失败",
          message: "不能添加自己为代理客户",
        });
        return;
      }
      for (var i = 0; i < this.agentGuestList.length; i++) {
        if (this.agentGuestList[i].GuestCode == this.selAgentCode) {
          this.$notify.error({ title: "失败", message: "已经选择了该用户" });
          return;
        }
      }

      var that = this;
      for (var i = 0; i < this.qryGuests.length; i++) {
        if (this.qryGuests[i].GuestCode == this.selAgentCode) {
          var agent = {
            ID: 0,
            SalerCode: this.agentGuest.GuestCode,
            GuestCode: this.qryGuests[i].GuestCode,
          };
          saveSForGuest(agent).then((resp) => {
            if (resp.data.code == 100) {
              that.$notify.success({ title: "成功", message: "保存成功" });
              that.freshGuestList(this.agentGuest.GuestCode);
              return;
            }
          });
          return;
        }
      }
    },
    onDelSForGuest(sfguest) {
      if (!confirm("是否确定删除？")) return;
      var that = this;
      delSForGuest(sfguest).then((resp) => {
        if (resp.data.code == 100) {
          that.$notify.success({ title: "成功", message: "删除成功" });
          that.freshGuestList(this.agentGuest.GuestCode);
          return;
        }
      });
    },
    showUpdateRoleType(guest){
        this.updateRoleGuest = {ID: guest.ID, GuestName: guest.GuestName, GuestCode: guest.GuestCode, RoleType: guest.RoleType};
        this.dlgUpdateRoleType = true;
    },
    onUpdateGuestRole(){
        var that = this;
        if (!confirm("是否确定修改用户角色？")) return;
        changeGuestRole(this.updateRoleGuest).then((resp) => {
            if (resp.data.code == 100) {
                that.$notify.success({ title: "成功", message: "保存成功" });
                that.dlgUpdateRoleType = false;
                that.onSearch();
            }
        })
    },
    //导入
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    beforeUpload(file) {
      //1上传前配置
      let excelfileExtend = ".xls,.xlsx"; //设置文件格式
      const isLt2M = file.size / 1024 / 1024 < 4;
      let fileExtend = file.name
        .substring(file.name.lastIndexOf("."))
        .toLowerCase();
      if (excelfileExtend.indexOf(fileExtend) <= -1) {
        this.$message.error("文件格式错误,格式必须为.xls,.xlsx！");
        return false;
      }
      this.uploadTip = "正在处理中...";
      this.processing = true;
    },
    //2上传成功
    uploadSuccess(response, file, fileList) {
      this.uploadTip = "点击上传";
      this.processing = false;
      if (response.data == 100) {
        this.$notify({
          title: "成功",
          message: "保存成功！",
          type: "success",
        });
        this.onBtnSearch();
      } else {
        this.$notify.error({
          title: "错误",
          message: "保存失败！\n\n错误：" + response.ErrMsg,
        });
      }
    },
    //上传文件出错
    uploadFail(err, file, fileList) {
      this.uploadTip = "点击上传";
      this.processing = false;
      this.$notify.error({
        title: "错误",
        message: "保存失败！\n\n错误：" + err,
      });
    },
    onShowWXQRCode(guest) {
      this.dialogWXQRCodeVisible = true;
      this.guestWXQRCodeSrc =
        appConfig.api_path + "guest/wxqrcode/" + guest.GuestCode;
    },
    onWXUnbind(guest){
      if (confirm("是否确定解绑【"+ guest.GuestName +"】的微信？")){
        var that = this;
        unbindGuestWX(guest).then((resp) => {
            if (resp.data.code == 100) {
                that.$notify.success({ title: "成功", message: "解绑成功" });
                that.onSearch();
            }
        })
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.guest-page {
  .cellunderline{
    text-decoration: underline;
    color:#20a0ff;
    cursor: pointer;
  }
}

</style>
